import { useParams } from "react-router-dom";
import { nameOf } from "../../Utils/nameOf";
import { Edc } from "../Edc";
import { EdcFormTabs } from "./EdcFormTabs";
import { useDeleteEdc } from "../Hooks/useDeleteEdc";
import { useFetchEdc } from "../Hooks/useFetchEdc";
import { useUpdateEdc } from "../Hooks/useUpdateEdc";

export const EditEdc = () => {
  const { edcId } = useParams();

  const { data: edc } = useFetchEdc(edcId);
  const { mutate: updateEdc } = useUpdateEdc(edcId);
  const { mutate: deleteEdc } = useDeleteEdc(edcId);

  const disabledFields: Array<string> = [
    nameOf<Edc>("Gsdb"),
    nameOf<Edc>("MgLatitude"),
    nameOf<Edc>("MgLongitude"),
    nameOf<Edc>("AltMgLatitude"),
    nameOf<Edc>("AltMgLongitude"),
  ];

  return (
    <EdcFormTabs
      title="Edit EDC"
      edc={edc}
      onSave={(it: Edc) => updateEdc(it)}
      onDelete={() => deleteEdc(edcId)}
      disabledFields={disabledFields}
    />
  );
};
